import { useBrandContext } from '../../context/BrandContext';
import arrowLeft from '../../assets/arrowLeft.svg';
import { OctagonAlert } from 'lucide-react';
import './CardCupomDetails.css';

export interface CardCupomDetailsData {
  dcId: string;
  dcAppId: string;
  dcCode: string;
  dcDescription: string;
  dcType: string;
  dcParameter: number;
  dcValidFrom: string;
  dcValidTo: string | null;
  dcNeverExpires: boolean;
  dcUsageLimit: number;
  dcTimeFrameFrom: string;
  dcTimeFrameTo: string;
  dcOnlyAboveValue: number;
  status: 'active' | 'inactive' | 'scheduled';
  available: boolean;
  applicationName: string;
  availableSite: string;
  udcRemainingValue: number | null;
}

export interface CardCupomDetailsProps {
  data: CardCupomDetailsData;
  setIsActiveRulesModalOpen: (value: any) => void;
  onClick?: (value: {}) => void;
}

export const CardCupomDetails = ({
  data,
  onClick,
  setIsActiveRulesModalOpen,
}: CardCupomDetailsProps) => {
  const { brandBgColor } = useBrandContext();

  const { dcCode, dcParameter, dcType, available, udcRemainingValue } = data;

  const percentTypes: string[] = ['DiscountCoupon', 'SalesCoupon'];
  const valueTypes: string[] = ['ValueOfVoucher'];

  return (
    <div className='coupon-wrapper' style={{ opacity: available ? 1 : 0.5 }}>
      <div className='coupon-container'>
        <div
          className='coupon-card'
          onClick={onClick && available ? () => onClick(data) : undefined}
        >
          <div className='coupon-card-header'>
            <h3 className='coupon-card-title'>{dcCode}</h3>
          </div>

          <div className='coupon-divider-section'>
            <div className='coupon-divider-line'></div>
            {onClick && available ? (
              <button
                className='coupon-arrow-button'
                style={{ backgroundColor: brandBgColor }}
              >
                <div className='coupon-white-circle'>
                  <img
                    src={arrowLeft}
                    alt='arrow-left'
                    className='coupon-arrow-icon'
                  />
                </div>
              </button>
            ) : (
              ''
            )}
          </div>

          <div className='coupon-card-body'>
            <p className='coupon-card-description'>
              Desconto de
              {valueTypes.includes(dcType) && ' R$'}
              {` ${dcParameter}`}
              {valueTypes.includes(dcType) && ' '}
              {percentTypes.includes(dcType) && '% '}
              em recargas
            </p>
            {udcRemainingValue !== null && udcRemainingValue !== undefined ? (
              <>
                <div
                  className='coupon-divider-line'
                  style={{ margin: '12px 0' }}
                ></div>
                <p
                  className='coupon-card-description'
                  style={{ marginBottom: 12 }}
                >
                  Valor restante de R${' '}
                  {new Intl.NumberFormat('pt', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(udcRemainingValue)}
                </p>
              </>
            ) : null}
            <div className='coupon-card-details'>
              <div
                className='coupon-card-rules'
                onClick={(e) => {
                  e.stopPropagation();
                  setIsActiveRulesModalOpen(data);
                }}
                style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
              >
                Regras
                <OctagonAlert width={14} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
